import { NgModule, NgModuleFactory, ModuleWithProviders } from '@angular/core';
import { CoreModule, LazyModuleFactory } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxsModule } from '@ngxs/store';
import { TerminalManagementComponent } from './components/terminal-management/terminal-management.component';
import { TerminalManagementRoutingModule } from './terminal-management-routing.module';
import { TerminalManagementState } from './states/terminal-management.state';
import { AppModuleManagementState } from './states/app-module-management.state';
import { TerminalLogState } from './states/terminal-log.state';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgPipesModule } from 'ngx-pipes';
import { AppModuleManagementComponent } from './components/app-module-management/app-module-management.component';
import { TerminalUsersModalComponent } from './components/terminal-management/terminal-users-modal.component';
import { TerminalAppModulesModalComponent } from './components/terminal-management/terminal-app-modules-modal.component';
import { TerminalLogComponent } from './components/terminal-log/terminal-log.component';


@NgModule({
	declarations: [
		TerminalManagementComponent,
		AppModuleManagementComponent,
		TerminalUsersModalComponent,
		TerminalAppModulesModalComponent,
		TerminalLogComponent
	],
	imports: [
		NgxsModule.forFeature([TerminalManagementState, AppModuleManagementState, TerminalLogState]),
		CoreModule,
		CommercialUiModule,
		ThemeSharedModule,
		TerminalManagementRoutingModule,
		NgbNavModule,
		NgbDropdownModule,
		NgxValidateCoreModule,
		NgPipesModule,
		NgbDatepickerModule
	],
	exports: [
		TerminalManagementComponent,
		AppModuleManagementComponent,
		TerminalUsersModalComponent,
		TerminalAppModulesModalComponent,
		TerminalLogComponent
	]
})
export class TerminalManagementModule {
	static forChild(): ModuleWithProviders<TerminalManagementModule> {
		return {
			ngModule: TerminalManagementModule,
			providers: [

			],
		};
	}

	static forLazy(): NgModuleFactory<TerminalManagementModule> {
		return new LazyModuleFactory(TerminalManagementModule.forChild());
	}
}
